import React from "react";
import image from "../../Assets/images/spinner.gif";
// import Loader from "react-loader-spinner";
const LoadingBtn = ({ is_loading, children, ...props }) => {
  return (
    <button {...props}>
      {is_loading ? (
        <div className="spinner-border" role="status"></div>
      ) : (
        children
      )}
    </button>
  );
};
export default LoadingBtn;
